import React from "react";
import "./Projects.css";

const featured = [
  {
    num: "01",
    title: "Phasor Data Concentrator (PDC)",
    period: "Jan 2025 – Present",
    description:
      "Go-based PMU ingestion service supporting IEEE C37.118 protocol with CRC validation and Kafka publishing. Event-driven pipeline with Redis, InfluxDB, and Prometheus — plus a React TypeScript operator dashboard with Recharts, React Leaflet, and SSE live updates.",
    stack: ["Go", "React", "TypeScript", "Kafka", "Redis", "InfluxDB", "SSE"],
    link: null,
    enterprise: "IIT Kanpur · Grid Monitoring",
  },
  {
    num: "02",
    title: "CVision — AI Resume Analyser",
    period: "Jun 2025 – Present",
    description:
      "AI-powered resume analysis with RAG pipeline extracting and matching skills from PDFs. Interactive dashboard with drag-and-drop uploads, real-time scoring gauges, and skill radar charts — containerised with Docker Compose.",
    stack: ["React", "FastAPI", "LangChain", "ChromaDB", "OpenAI", "Docker"],
    link: "https://github.com/Kashish-Shukla18/resume-analysis-rag",
    verified: true,
  },
];

const projects = [
  {
    num: "03",
    title: "WorkSpace Connect",
    period: "Jan 2025 – May 2025",
    description:
      "Full-stack team workspace with 40+ REST API endpoints, live Socket.IO messaging with user-scoped rooms, employee management with CRUD and pagination, and a live metrics dashboard deployed on Render.",
    stack: ["React 19", "Node.js", "PostgreSQL", "Socket.IO"],
    link: null,
    enterprise: "Personal Project",
  },
  {
    num: "04",
    title: "Breaker Guard — Utility Operations",
    period: "Jul 2025 – Dec 2025",
    description:
      "Utility operations platform for UPPCL consolidating outage management, IoT device monitoring, and OTA firmware deployment. RBAC, OTP verification, geolocation mapping — reduced outage response time by 40%.",
    stack: ["Django", "React", "PostgreSQL", "Bootstrap", "IoT"],
    link: "https://github.com/Kashish-Shukla18/Breaker_Guard",
    verified: true,
  },
  {
    num: "05",
    title: "Energy Management & PMU Platform",
    period: "Dec 2024 – Present",
    description:
      "Real-time EMS processing 10,000+ messages/sec across 15+ substations. React 19 dashboard with WebSockets, SSE, and Recharts — 99.9% system availability with Kafka, FastAPI, and InfluxDB.",
    stack: ["React 19", "Django", "FastAPI", "Kafka", "InfluxDB", "Redis"],
    link: null,
    enterprise: "IIT Kanpur · Energy Division",
  },
  {
    num: "06",
    title: "GREET Research & UPCON 2026",
    period: "2024 – Present",
    description:
      "Production web platforms with survey automation, email notifications, Excel report generation, paper submissions, registrations, and responsive UI for research and conference management.",
    stack: ["Django", "React.js", "PostgreSQL", "SMTP", "REST APIs"],
    link: null,
    enterprise: "IIT Kanpur",
  },
  {
    num: "07",
    title: "Incubation & NIDHI SSS Portal",
    period: "Jun 2024 – Dec 2024",
    description:
      "React & Laravel portal with role-based dashboards, multi-stage workflows, PDF/ZIP document management, bulk CSV exports, and SMTP notifications for 500+ monthly submissions.",
    stack: ["React.js", "Laravel", "MySQL", "PHP", "DomPDF", "Vite.js"],
    link: null,
    enterprise: "SIIC · IIT Kanpur",
  },
  {
    num: "08",
    title: "MedTech CoE Website",
    period: "2024",
    description:
      "Institutional website for SIIC MedTech Centre of Excellence with PHP, Bootstrap, reusable modular components, and fully responsive layouts.",
    stack: ["PHP", "Bootstrap", "JavaScript", "Responsive UI"],
    link: null,
    enterprise: "medtechcoe.siicincubator.com",
  },
];

function ProjectCard({ project, className = "" }) {
  return (
    <article className={`project-card ui-card reveal ${className}`}>
      <div className="project-card__top">
        <span className="ui-badge ui-badge--muted">
          {project.verified ? "Open Source" : "Enterprise"}
        </span>
        <span className="project-card__num">{project.num}</span>
      </div>

      <div className="project-card__body">
        <h3 className="card-title">{project.title}</h3>
        {project.period && <p className="project-card__period">{project.period}</p>}
        <p className="card-body project-card__desc">{project.description}</p>
        <div className="tag-row">
          {project.stack.map((s) => (
            <span key={s} className="tag">{s}</span>
          ))}
        </div>
      </div>

      <div className="project-card__footer">
        {project.link ? (
          <a
            href={project.link}
            target="_blank"
            rel="noreferrer"
            className="project-card__link"
          >
            View on GitHub <span className="arrow">→</span>
          </a>
        ) : (
          <span className="project-card__enterprise">{project.enterprise}</span>
        )}
      </div>
    </article>
  );
}

function Projects() {
  return (
    <section id="projects" className="projects section-band">
      <div className="section-inner">
        <header className="section-header">
          <div className="section-label">Projects</div>
          <h2 className="section-title">
            Selected <em>Work</em>
          </h2>
          <p className="section-subtitle">
            From real-time grid monitoring and GenAI platforms to enterprise portals at IIT Kanpur & SIIC.
          </p>
        </header>

        <div className="projects__featured">
          {featured.map((project) => (
            <ProjectCard key={project.num} project={project} className="project-card--featured" />
          ))}
        </div>

        <div className="projects__grid">
          {projects.map((project) => (
            <ProjectCard key={project.num} project={project} />
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
